import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs/internal/Observable";

import { EjeroplysningerSandbox } from "./ejeroplysninger.sandbox";
import { EjeroplysningerViewModel } from "./model/ejeroplysninger.view-model";

@Component({
    selector: "e-forsyning-ejeroplysninger",
    templateUrl: "./ejeroplysninger.component.html"
})
export class EjeroplysningerComponent implements OnInit {
    public vm$: Observable<EjeroplysningerViewModel>;

    public constructor(private readonly sandbox: EjeroplysningerSandbox) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.hentViewModel();
    }
}
